import { Core } from '@springtree/eva-services-core';
import productDetailState from './product-detail-state.js';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from '../current-user/current-user-state.js';
const productDetailsAvailabilityState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailAvailability',
    service: Core.GetProductAvailability,
    beforeRequest: ({ req, get }) => {
        const currentProduct = get(productDetailState.response);
        const currentUser = get(currentUserState.response);
        const productId = currentProduct && currentProduct.Result?.product_id;
        if (!productId) {
            return;
        }
        const organizationUnitsForPickup = [];
        if (currentUser?.User?.CurrentOrganizationID) {
            organizationUnitsForPickup.push(currentUser.User.CurrentOrganizationID);
        }
        const newRequest = {
            Options: {
                Bundles: {
                    IncludeBundleInformation: true,
                },
                Delivery: {
                    AvailabilityDate: true,
                },
                Pickup: {
                    AvailabilityDate: true,
                    OrganizationUnitIDs: organizationUnitsForPickup,
                },
                QuantityAvailable: true,
                ProductAvailabilityDetails: {
                    OrganizationUnitIDs: organizationUnitsForPickup,
                    ProductIDs: [productId],
                },
            },
            ...req,
            Products: [
                {
                    ID: productId,
                    QuantityRequested: 1,
                },
            ],
        };
        return newRequest;
    },
});
export default productDetailsAvailabilityState;
//# sourceMappingURL=product-detail-availability-state.js.map